// extracted by mini-css-extract-plugin
export default {"appHeader":"BJe6d","userAvatar":"W6Ubp","themeIcon":"JYm0B","switcher":"p4TZO","on":"sU4Vt","icon":"_ttkG","dstackVersion":"e20I6"};